import { useSelector } from 'react-redux';

import RootState from 'types/state/RootState';

const useGoogleMapsKey = (): string => {
    return useSelector((state: RootState): string => state.googleMapsKey || '');
};

export default useGoogleMapsKey;
